export function getLocalStoreName() {
    if (typeof window === 'undefined') {
        return '';
    }
    const marketPath = window.stockcarsMarketPath ? window.stockcarsMarketPath : '';
    const startPage = window.stockcarsScsStartPage
        ? window.stockcarsScsStartPage
        : '';
    return `VTP_${marketPath}_${startPage}`;
}
export function getFilterPresetHash(store) {
    if (store) {
        const storeObj = JSON.parse(store);
        const { filterParams } = storeObj;
        if (filterParams) {
            const activeFilters = filterParams.filter
                .map((filterDTO) => filterDTO.toString())
                .join(',');
            const activePresets = filterParams.preset
                .map((filterDTO) => filterDTO.toString())
                .join(',');
            const filterString = `filter=${activeFilters}`;
            const presetsString = `preset=${activePresets}`;
            return `#${activeFilters ? filterString : ''}${activeFilters && activePresets ? '&' : ''}${activePresets ? presetsString : ''}`;
        }
    }
    return '';
}
export function readFilterFromLocalStore() {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
        const storeName = getLocalStoreName();
        const store = localStorage && localStorage.getItem(storeName);
        if (store) {
            return getFilterPresetHash(store);
        }
    }
    return '';
}
